import { useAuth } from '../context/AuthContext';

/**
 * Custom hook to get current user information and auth state
 * This can be imported and used in any component that needs user data
 * 
 * @returns {Object} Object containing:
 *   - user: Current user data or null
 *   - isAuthenticated: Boolean indicating if user is logged in
 *   - isLoading: Boolean indicating if auth state is still loading
 *   - login: Function to log user in
 *   - logout: Function to log user out
 *   - updateUser: Function to update user data
 */
export const useUser = () => {
  const auth = useAuth();
  return auth;
}; 